import { TFunction } from 'react-i18next';

export const formatAccountStatus = (isActive: boolean, archived: boolean, t: TFunction): string => {
  if (archived) {
    return t('AccountItem.archived');
  }
  switch (isActive) {
    case true:
      return t('AccountItem.active');
    case false:
      return t('AccountItem.nonActive');
    default:
      return isActive;
  }
};
